import { enumLabel } from "helpers/system";
import React from "react";

const ShowScenario = ({ name, description, startQuestionId, questionOptions, externalData }) => {
    return (
        <>
            <h5>{name}</h5>
            <div className="text-muted">{description}</div>
            <div className="text-muted">PropertyName: {externalData?.propertyName || "—"}</div>
            <div>
                <strong>Начальный вопрос:&nbsp;</strong>
                <span>{enumLabel(questionOptions, startQuestionId)}</span>
            </div>
        </>
    );
};

export default ShowScenario;
